<template>
  <div id="app" class="poll">

    <div v-if="steps[current]" class="poll__info">
      <span class="poll__current">{{ current + 1 }}</span>
      <span class="poll__total">{{ steps.length }}</span>
    </div>

    <div class="poll__inner">
      <Start v-if="current < 0" @goNext="goNext"></Start>

      <Step
          v-if="steps[current]  && !isFinish"
          :title="steps[current].title"
          :options="steps[current].options"
          :index="current"
          v-model="value"
          @change="onChange"
          @goPrev="goPrev"
      ></Step>

<!--      <Results v-if="isFinish" :result="result"></Results>-->

    </div>

  </div>
</template>

<script>
import Start from './components/Start.vue'
import Step from './components/Step.vue'
import Results from './components/Results.vue'

const getRandomInt = max => {
  max = Math.floor(max);
  return Math.floor(Math.random() * max);
}

export default {
  name: 'App',

  data() {
    return {
      steps: [
        {
          title: 'В какое из этих мест вы хотели бы отправиться?',
          options: [
            {
              title: 'Милан',
              events: [0]
            },
            {
              title: 'Лос Анджелес',
              events: [1]
            },
            {
              title: 'Пустыня',
              events: [2]
            },
            {
              title: 'Доха',
              events: [3]
            },
            {
              title: 'Майами',
              events: [4]
            },
            {
              title: 'Канны',
              events: [5]
            },
            {
              title: 'Рио-де-Жанейро',
              events: [6]
            },
            {
              title: 'Венеция',
              events: [7]
            },
            {
              title: 'Нью Йорк',
              events: [8]
            },
            {
              title: 'Осло',
              events: [9]
            }
          ],
        },
        {
          title: 'Как вы любите воспринимать этот мир?',
          options: [
            {
              title: 'Визуально',
              events: [0, 1, 5, 7, 8]
            },
            {
              title: 'Через речь, музыку, звуки',
              events: [2, 6]
            },
            {
              title: 'Через тактильность, прикосновения и ощущения',
              events: [3, 9, 4]
            }
          ],
        },
        {
          title: 'Что вы любите больше?',
          options: [
            {
              title: 'Музыка',
              events: [2]
            },
            {
              title: 'Кино',
              events: [1]
            },
            {
              title: 'Искусство',
              events: [7]
            },
            {
              title: 'Реклама',
              events: [5]
            },
            {
              title: 'Мода',
              events: [8, 0]
            },
            {
              title: 'Спорт',
              events: [3, 4]
            }
          ],
        },
        {
          title: 'Вы любите соревнования?',
          options: [
            {
              title: 'Да',
              events: [1, 3, 5, 4, 8, 9]
            },
            {
              title: 'Нет',
              events: [0, 2, 6, 7]
            }
          ],
        },
        {
          title: 'Какой из этих цветов вам нравится больше?',
          options: [
            {
              title: 'Красный',
              events: [3, 7, 8]
            },
            {
              title: 'Золотистый',
              events: [1, 9]
            },
            {
              title: 'Серебристый',
              events: [4]
            },
            {
              title: 'Черный',
              events: [0, 2, 5]
            },
            {
              title: 'Все цвета люблю!',
              events: [6]
            },
          ],
        },
        {
          title: 'Что вы выберете?',
          options: [
            {
              title: 'Рок',
              events: [6]
            },
            {
              title: 'Рэп',
              events: [3, 4]
            },
            {
              title: 'Поп',
              events: [8, 0, 5]
            },
            {
              title: 'Электронная музыка',
              events: [2]
            },
            {
              title: 'Классика',
              events: [7, 9, 1]
            }
          ],
        },
        {
          title: 'На что вы в первую очередь полагаетесь, чувства или разум?',
          options: [
            {
              title: 'Чувства',
              events: [6, 0, 2, 1, 8]
            },
            {
              title: 'Разум',
              events: [9, 7, 5, 3, 4]
            }

          ],
        },
        {
          title: 'Кто вы по знаку Зодиака?',
          options: [
            {
              title: 'Овен',
              events: [1, 5, 9, 7]
            },
            {
              title: 'Близнец',
              events: [7, 9, 2]
            },
            {
              title: 'Телец',
              events: [7, 9]
            },
            {
              title: 'Рак',
              events: [2, 8]
            },
            {
              title: 'Лев',
              events: [1, 8, 3, 4, 2]
            },
            {
              title: 'Весы',
              events: [9, 0, 7, 2]
            },
            {
              title: 'Дева',
              events: [0, 8, 9]
            },
            {
              title: 'Скорпион',
              events: [9, 3, 6]
            },
            {
              title: 'Стрелец',
              events: [6, 4, 7, 2]
            },
            {
              title: 'Водолей',
              events: [9, 4, 7, 0]
            },
            {
              title: 'Козерог',
              events: [7, 9, 8, 4]
            },
            {
              title: 'Рыбы',
              events: [0, 8]
            }
          ],
        },
      ],
      current: -1,
      events: {
        0: 'неделя моды в милане',
        1: 'оскар',
        2: 'burning man',
        3: 'fifa world cup 2020',
        4: 'super bowl',
        5: 'канские львы',
        6: 'карнавал в рио',
        7: 'венецианское биеннале',
        8: 'met gala',
        9: 'нобелевская премия'
      },
      scores: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      answers: [],
      value: null,
      isFinish: false,
      result: -1,
      urls: {
        0: 'fashion',
        1: 'oskar',
        2: 'burning-man',
        3: 'fifa',
        4: 'superbowl',
        5: 'leons',
        6: 'karnaval',
        7: 'biennale',
        8: 'met-gala',
        9: 'nobel',
      }
    }
  },

  components: { Start, Step, Results },

  mounted() {
    // const images = [
    //   '@/assets/fashion.jpg',
    //   '@/assets/oskar.jpg',
    //   '@/assets/burning-man.jpg',
    //   '@/assets/fifa.jpg',
    //   '@/assets/superbowl.jpg',
    //   '@/assets/leons.jpg',
    //   '@/assets/karnaval.jpg',
    //   '@/assets/fashion.jpg',
    //   '@/assets/met-gala.jpg',
    //   '@/assets/nobel.jpg',
    // ]
  },

  methods: {
    goNext() {
      if (this.current >= this.steps.length - 1) {
        this.isFinish = true
        this.calcResult()
        return
      }

      const nextIndex = this.current + 1
      this.saveLastAnswer()
      this.goTo(nextIndex)
    },

    goPrev() {
      if (this.current <= 0) return

      const prevIndex = this.current - 1
      this.removeLastAnswer()
      this.goTo(prevIndex)
    },

    goTo(index) {
      this.current = index
    },

    getScore() {
      this.answers.forEach(answer => {
        answer.forEach(i => {
          this.scores[i]++
        })
      })
    },

    saveLastAnswer() {
      if (!this.value) return

      this.answers.push(this.value.events)
    },

    removeLastAnswer() {
      if (!this.value) return

      this.answers.pop()
    },

    calcResult() {
      this.getScore()
      // const arr = [0,1,1,5,3,5,1,2,2,0];
      const max = Math.max(...this.scores)
      const indexes = []
      this.scores.forEach((i, index) => i === max ? indexes.push(index) : null)
      const index = getRandomInt(indexes.length)
      this.result = indexes[index]
      window.location = `https://eventum-premo.ru/valentine-2020/${this.urls[this.result]}.html`
    },

    onChange() {
      setTimeout(this.goNext, 1000)
    }
  }
}
</script>
